import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { BarChart3 } from "lucide-react";

interface WeaverAnalyticsProps {
  storeId: string;
}

const WeaverAnalytics = ({ storeId }: WeaverAnalyticsProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <BarChart3 className="h-5 w-5" />
          Analytics Dashboard
        </CardTitle>
        <CardDescription>Track your store performance and insights</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <p className="text-sm text-muted-foreground">Store ID: {storeId}</p>
          <div className="p-8 border-2 border-dashed rounded-lg text-center">
            <BarChart3 className="h-12 w-12 mx-auto mb-4 text-muted-foreground" />
            <h3 className="font-medium mb-2">Analytics Coming Soon</h3>
            <p className="text-sm text-muted-foreground">
              Charts, graphs, and detailed analytics will be displayed here.
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default WeaverAnalytics;
